import { cn } from "@newxsystems/shared";
import { BlockImage } from "../../../shared/components/BlockImage/BlockImage";
import { BlockVideoPlayer } from "../../../shared/components/BlockVideoPlayer/BlockVideoPlayer";
import type { ITextMediaRegionProps } from "./TextMediaRegion.props";

const getVideoUrl = (video: NonNullable<ITextMediaRegionProps["video"]>) => {
  switch (video.source) {
    case "direct":
      return video.directVideo;
    case "youtube":
      return video.youtubeVideo;
    case "vimeo":
      return video.vimeoVideo;
  }
};

export const TextMediaRegion = ({ className, image, title, video }: ITextMediaRegionProps) => {
  const videoUrl = video ? getVideoUrl(video) : undefined;

  if (!image && !videoUrl) {
    return null;
  }

  return (
    <div className={cn("grid min-w-0 gap-6", className)}>
      {image ? (
        <BlockImage
          className="shrink-0 overflow-hidden rounded-[14px] border border-foreground bg-foreground"
          effectiveAspectRatio={image.aspectRatio ?? "16:9"}
          image={image}
          imageClassName="object-cover"
          loading="lazy"
        />
      ) : null}
      {video && videoUrl ? (
        <BlockVideoPlayer
          banner={video.banner}
          className="rounded-[14px] border border-foreground"
          source={video.source}
          title={title || video.banner?.image.alternateText || video.source}
          url={videoUrl}
        />
      ) : null}
    </div>
  );
};

TextMediaRegion.displayName = "TextMedia::TextMediaRegion";
